import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18c4072b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c4072b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18c4072b')) {
      api.createRecord('18c4072b', component.options)
    } else {
      api.reload('18c4072b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=18c4072b&scoped=true", function () {
      api.rerender('18c4072b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabMessage/index.vue"
export default component.exports